import { Alert, Snackbar } from "@mui/material";
import { Box, useTheme } from "@mui/system";
import { useState } from "react";
import useStyles from "./styles";
import ConfigReferenciaServico from "./configReferenciaServico";
import ConfigExibicaoCliente from "./configExibicaoCliente";

export default function Clientes() {
  const theme = useTheme();
  const styles = useStyles(theme);

  const erp = window?.config?.REACT_APP_ERP || process.env.REACT_APP_ERP;

  const [snackbar, setSnackbar] = useState(null);
  const [editConfig, setEditConfig] = useState(true);

  return (
    <Box sx={{ width: "100%", p: 2 }}>
      {(erp === "HUBSOFT" || erp === "IXC") && <ConfigReferenciaServico />}
      <ConfigExibicaoCliente />
      {!!snackbar && (
        <Snackbar
          open
          onClose={() => setSnackbar(null)}
          autoHideDuration={3000}
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        >
          <Alert {...snackbar} onClose={() => setSnackbar(null)} />
        </Snackbar>
      )}
    </Box>
  );
}
